'use client';

import { LogoSmall } from '../../Logo';
import {
  Disclosures,
  DisclosuresContainer,
  ExtraLinksContainer,
  FullWidthFooterContainer,
  LinkColumnTitle,
  LinksColumn,
  LinksContainer,
  MaxWidthContainer,
  ResourceLinksContainer,
  SocialLinksContainer,
  TitleContainer,
  TitleText,
} from './FooterRedesign.style';
import { footerData } from './data/footer-data';

export const FooterRedesign = () => {
  return (
    <FullWidthFooterContainer>
      <MaxWidthContainer>
        <TitleContainer>
          <LogoSmall />
          <TitleText>{footerData.footerText.title}</TitleText>
        </TitleContainer>
        <LinksContainer>
          <LinksColumn>
            <LinkColumnTitle>TITLE</LinkColumnTitle>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
          </LinksColumn>
          <LinksColumn>
            <LinkColumnTitle>TITLE</LinkColumnTitle>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
          </LinksColumn>
          <LinksColumn>
            <LinkColumnTitle>TITLE</LinkColumnTitle>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
          </LinksColumn>
          <LinksColumn>
            <LinkColumnTitle>TITLE</LinkColumnTitle>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
            <a href="/">link</a>
          </LinksColumn>
        </LinksContainer>
        <DisclosuresContainer>
          <ExtraLinksContainer>
            <ResourceLinksContainer>
              <a href="/">link</a>
              <a href="/">link</a>
              <a href="/">link</a>
              <a href="/">link</a>
            </ResourceLinksContainer>
            <SocialLinksContainer>
              <a href="/">link</a>
              <a href="/">link</a>
              <a href="/">link</a>
              <a href="/">link</a>
            </SocialLinksContainer>
          </ExtraLinksContainer>
          <Disclosures>
            <div>disclosure text</div>
            <div>disclosure text</div>
            <div>disclosure text</div>
            <div>disclosure text</div>
          </Disclosures>
        </DisclosuresContainer>
      </MaxWidthContainer>
    </FullWidthFooterContainer>
  );
};
